import { Typography } from '@material-ui/core';
import { CustomViewRegister } from '../CustomView/registry';
import { GenericField } from '../DisplayValue';
import { CustomViewGridElement } from './utility';

CustomViewRegister.register({
  id: 'cost_display',
  function: function Stars({
    value,
    label,
    locale = 'de-DE',
    currency,
    cadency,
    colSpan,
    align,
  }: Record<string, any>) {
    const formatted = value
      ? new Intl.NumberFormat(
          locale,
          currency ? { style: 'currency', currency } : undefined,
        ).format(value)
      : '-';

    const content = (
      <div>
        <Typography variant="h3" component="span">
          {formatted}
        </Typography>
        {cadency && <Typography component="span">/{cadency}</Typography>}
      </div>
    );
    return (
      <CustomViewGridElement colSpan={colSpan} align={align}>
        <GenericField label={label} value={content} />
      </CustomViewGridElement>
    );
  },
});
